export const SHIP_STATION_ROUTES = {
  LOGIN: 'https://signin.shipstation.com/login',
  SHIP_FROM_LOCATIONS: 'https://ship.shipstation.com/settings/warehouses',
  CARRIERS: 'https://ship.shipstation.com/settings/carriers'
};
